export default "__VITE_ASSET__DegN_1bL__"